export const PORTAL_TOOL_EXECUTE_SSE_EVENT_NAME =
  'portal-tool-execute' as const;

export const PORTAL_TOOL_NAVIGATE_EVENT = 'terra-portal-tool-navigate' as const;

export const PROXY_CONTROL_TOOL_NAME = 'proxy-control-tool' as const;
export const INTERCEPT_TOGGLE_TOOL_NAME = 'intercept-toggle-tool' as const;
export const INTERCEPT_RULE_TOOL_NAME = 'intercept-rule-tool' as const;
export const MATCH_REPLACE_RULE_TOOL_NAME = 'match-replace-rule-tool' as const;
export const REPLAY_REQUEST_TOOL_NAME = 'replay-request-tool' as const;
export const LAUNCH_BROWSER_TOOL_NAME = 'launch-browser-tool' as const;

export const PROXY_HISTORY_TOOL_NAME = 'read-captured-proxy-requests' as const;

export const BROWSER_AUTOMATION_TOOL_NAME = 'browser-automation-tool' as const;

export const TRACK_HISTORY_REQUEST_TOOL_NAME =
  'track-history-request-tool' as const;

export const MCP_OAUTH_AUTHORIZE_TOOL_NAME =
  'mcp-oauth-authorize-tool' as const;

export const MCP_CREDENTIAL_DIALOG_TOOL_NAME =
  'mcp-credential-dialog-tool' as const;

export const MCP_CONNECTION_PORTAL_TOOL_NAMES = [
  MCP_OAUTH_AUTHORIZE_TOOL_NAME,
  MCP_CREDENTIAL_DIALOG_TOOL_NAME,
] as const;

export const PORTAL_TOOL_NAMES = [
  PROXY_CONTROL_TOOL_NAME,
  INTERCEPT_TOGGLE_TOOL_NAME,
  INTERCEPT_RULE_TOOL_NAME,
  MATCH_REPLACE_RULE_TOOL_NAME,
  REPLAY_REQUEST_TOOL_NAME,
  LAUNCH_BROWSER_TOOL_NAME,
  PROXY_HISTORY_TOOL_NAME,
  BROWSER_AUTOMATION_TOOL_NAME,
  TRACK_HISTORY_REQUEST_TOOL_NAME,
  MCP_OAUTH_AUTHORIZE_TOOL_NAME,
  MCP_CREDENTIAL_DIALOG_TOOL_NAME,
] as const;

export type PortalToolName = (typeof PORTAL_TOOL_NAMES)[number];
